module.exports = __webpack_public_path__ + "static/media/image-5.abb6f2d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Neighborhood/image-5.png
// module id = 266
// module chunks = 0